<template>
  <b-container>
    <b-row>
      <div class="col-7 offset-md-2 top-padding">
        <h3>{{$t('resendEmailTitle')}}</h3>
        <br>
        <div v-if="!isApiCallComplete">
          <fieldset class="form-group">
            <legend style="text-align: left;">{{$t('email')}}</legend>
            <div class="select-container">
              <b-input
                v-model="email"
                class="style-input"
                size="lg"
                @blur.native="handleEmailBlur"
                :state="emailState"
              />
              <p v-if="!emailState && wasEmailInput" class="danger-text">{{$t('invalidEmailFormat')}}</p>
            </div>
          </fieldset>
          <fieldset class="form-group">
            <legend style="text-align: left;">{{$t('licenseCode')}}</legend>
            <div class="select-container">
              <b-input
                v-model="laCode"
                class="style-input"
                size="lg"
              />
            </div>
          </fieldset>
          <div class="recaptcha-container" v-if="!UrlBuilder.isInternalUser && !($route.params && $route.params.internal === 'true')">
            <vue-recaptcha
              :sitekey="'6LeElsEUAAAAALSyQQonPyKb7kcenuaDLUmdodjN'"
              @verify="verifyRecaptcha"
              @expired="handleRecaptchaExpiry"
            />
          </div>
          <div class="col-12 text-center">
            <b-button
              class="cta-btn"
              variant="primary"
              size="lg"
              :disabled="isSubmitButtonDisabled || isSubmitting"
              @click="sendEmail"
            >
              {{ isSubmitting ? $t('submitting') + '...' : $t('submit') }}
            </b-button>
          </div>
        </div>
        <div v-else style="margin-top: 30px;">
          <b-alert
            dismissible
            @dismissed="clearScreen"
            v-model="alert"
            :variant="wasApiSuccessful ?($route.params.internal==='true'?'success':'success') :($route.params.internal==='true'?'danger':'success')"
          >
            {{
              wasApiSuccessful
                ?($route.params.internal === 'true'? $t('resendEmailSuccessMessage'):$t('resendEmailExternalMessage'))
                :($route.params.internal === 'true'? $t('resendEmailFailureMessage'):$t('resendEmailExternalMessage')) 
            }}
          </b-alert>
        </div>
      </div>
      <div class="col-3" v-if="!$route.params.internal">
        <div class="globe-icon-padding">
          <span class="m-1 fa fa-globe fa-2x"></span>
          <b-form-select
          v-model="selectedLocal"
          :options="langauges"
          @change.native="onSelectLocal" 
          class="mb-3 locale-label"
          value-field="key"
          text-field="value"
          disabled-field="notEnabled"
          ></b-form-select>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

let locale = 'en'
export default {
  name: 'Email',
  components: { VueRecaptcha },
  data () {
    this.$i18n.locale = 'en'
    return {
      email: '',
      laCode: '',
      isSubmitting: false,
      wasEmailInput: false,
      isEmailValid: false,
      recaptchaVerified: this.UrlBuilder.isInternalUser || (this.$route.params && this.$route.params.internal === 'true'),
      alert: true,
      isApiCallComplete: false,
      wasApiSuccessful: false,
      selectedLocal: 'en',
      langauges: [
        {
          key: 'en',
          value: 'English (US)'
        },
        {
          key: 'de-DE',
          value: 'Deutsch (Deutschland)'
        },
        {
          key: 'fr-FR',
          value: 'Francais (France)'
        },
        {
          key: 'es-CO',
          value: 'Español'
        },
        {
          key: 'pt-BR',
          value: 'Português (Brasil)'
        },
        {
          key: 'jp-JP',
          value: '日本語'
        },
        {
          key: 'ko-KR',
          value: '한국어'
        },
        {
          key: 'zh-CN',
          value: '简体中文'
        },
        {
          key: 'zh-TW',
          value: '繁體中文'
        }
      ]
    }
  },
  computed: {
    emailState () {
      if (!this.wasEmailInput) return null
      return this.isEmailValid
    },
    staticDirPrefix () {
      const devEnv = 'development'
      const env = process.env.NODE_ENV || devEnv
      return env === devEnv ? '' : '/licensingui'
    },
    isSubmitButtonDisabled () {
      return !this.isEmailValid || !this.laCode || !this.recaptchaVerified
    }
  },
  methods: {
    handleEmailBlur (evt) {
      if (evt.data === null) {
        this.wasEmailInput = false
      } else {
        this.wasEmailInput = true
        // eslint-disable-next-line
        this.isEmailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          .test(String(this.email).toLowerCase().trim())
      }
    },
    verifyRecaptcha (response) {
      this.recaptchaVerified = !!response
    },
    handleRecaptchaExpiry (response) {
      this.recaptchaVerified = false
    },
    sendEmail () {
      this.isSubmitting = true
      this.alert = true
      this.bottle
        // hard-coded URL, change later
        .post(this.UrlBuilder.resendEmailUrl, {
          LicensingAllocationCode: this.laCode,
          EmailId: this.email
        })
          .then((response) => {
            this.wasApiSuccessful = true
          })
          .catch((error) => {
            if (error.response.status == 400) // eslint-disable-line
              this.wasApiSuccessful = false
            this.loggly.log({
              errorMessage: 'Failed to resend email',
              errorObject: error,
              errorStack: error.stack
            })
          })
          .finally(() => {
            this.isApiCallComplete = true
            this.isSubmitting = false
          })
    },
    clearScreen () {
      this.isApiCallComplete = false
      this.email = ''
      this.laCode = ''
      this.isSubmitting = false
      this.wasEmailInput = false
      this.isEmailValid = false
      this.recaptchaVerified = this.UrlBuilder.isInternalUser || (this.$route.params && this.$route.params.internal === 'true')
      this.wasApiSuccessful = false
    },
    onSelectLocal (evt) {
      locale = evt.target.value || locale
      if (!locale.includes('en')) {
        this.$store.dispatch('fetchLocaleJson', {
          bottle: this.bottle,
          url: `${this.staticDirPrefix}/static/${locale}.json`
        })
        .then(() => {
          this.$i18n.setLocaleMessage(locale, this.$store.getters.localeJson)
          this.$i18n.locale = locale
        })
        .catch(this.handleError)
      } else {
        this.$i18n.locale = locale
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  fieldset {
    border-radius: 5px;
    padding: 10px 0 0;
    width: 100%;
  }
  fieldset > legend {
    padding: 0 10px;
    margin-left: 10px;
    width: auto;
    font-size: 14px;
    color: $darkGray;
    margin-bottom: 0;
    z-index: $legendZIndex;
    position: relative;
    background-color: white;
  }
  .select-container {
    margin: -20px 0 0;
    min-height: 40px;
  }
  .style-input:not(.is-invalid) {
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: 1px solid $lightGray;
  }
  .cta-btn {
    border-radius: 25px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 30px;
    padding-right: 30px;
  }
  .recaptcha-container {
    display: flex;
    justify-content: left;

  }
  .danger-text {
    color: $danger;
  }
  .locale-label {
    width: 75% !important;
    position: absolute;
    border: none;
    font-family: Citrix-Semibold;
  }
  .top-padding{
    padding-top: 10px;
  }
  .globe-icon-padding{
    border-radius: 30px;
    border: 1px solid lightgray;
    padding: 8px;
    position: relative;
    top: 3px;
    left: 9px;
    padding-bottom: 6px;
    padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Email.vue